import React, { useState, useEffect, useContext } from "react";
import { Redirect, Route, Link, useLocation } from "react-router-dom";
import auth from "services/auth";
import api from "services/api";
import AppContext from "contexts/AppContext";
import Translator, { __ } from "services/Translator";
import { useSelector } from "react-redux";
import { VIPImage } from "elements/VipLevelText";

import { Dropdown, Badge } from "react-bootstrap";
const UserDropDownMenu = (props) => {
  const location = useLocation();
  const activeMenu = location.pathname;
  const userBalance = useSelector((state) => state.userBalance);
  const { updateUserAuthStatus } = useContext(AppContext);
  const [defualtShowing, setDefaultShowing] = useState(false);

  const logout = async (ev) => {
    ev.preventDefault();
    await auth.logout();
    updateUserAuthStatus();
  };

  //Verify id checking

  const [level2submitted, setLevel2submitted] = useState(false);
  const [level2Verification, setLevel2Verification] = useState(false);

  const [level3submitted, setLevel3submitted] = useState(false);
  const [level3Verification, setLevel3Verification] = useState(false);

  const [level4submitted, setLevel4submitted] = useState(false);
  const [level4Verification, setLevel4Verification] = useState(false);

  const getIdUploads = async () => {
    var response = await api.get("/id-uploads");
    console.log("id-uploadsid-uploads", response);
    if (response.status === 200 && response.data) {
      if (response.data.poif && response.data.poib) {
        if (
          response.data.poif.approved == "approved" &&
          response.data.poib.approved == "approved"
        ) {
          setLevel2Verification(true);
        } else if (
          response.data.poif.approved == "submitted" &&
          response.data.poib.approved == "submitted"
        ) {
          setLevel2submitted(true);
        }
      }

      if (response.data.poa) {
        if (response.data.poa.approved == "approved") {
          setLevel3Verification(true);
        } else if (response.data.poa.approved == "submitted") {
          setLevel3submitted(true);
        }
      }
      if (response.data.sof) {
        if (response.data.sof.approved == "approved") {
          setLevel4Verification(true);
        } else if (response.data.sof.approved == "submitted") {
          setLevel4submitted(true);
        }
      }
    }
  };

  useEffect(() => {
    if (props.isAuthenticated) {
      getIdUploads();
    }
  }, []);

  const [showMainNotification, setShowMainNotification] = useState(false);
  useEffect(() => {
    if (
      props.freeSpinCount > 0 ||
      props.notifictionCount > 0 ||
      props.messageCount ||
      !level2submitted ||
      !level3submitted
    ) {
      setShowMainNotification(true);
    } else {
      setShowMainNotification(false);
    }
  }, [props]);

  return (
    <>
      {defualtShowing && (
        <>
          <div
            className="backDrop"
            onClick={() => {
              setDefaultShowing(false);
            }}
          ></div>
        </>
      )}
      <Dropdown show={defualtShowing} className="userDropdownMenu">
        {props.isMobileDevice && (
          <Dropdown.Toggle
            onClick={() => {
              setDefaultShowing(!defualtShowing);
              if (props.isMobileDevice) {
                props.setShowPreLeftSidebar(false);
              }
            }}
            variant="success"
            className="main_notification"
          >
            <i class="far fa-user"></i>

            {showMainNotification && <div className="notification_round"></div>}
          </Dropdown.Toggle>
        )}
        {!props.isMobileDevice && (
          <Dropdown.Toggle
            onClick={() => {
              setDefaultShowing(!defualtShowing);
            }}
            variant="success"
            className="main_notification"
          >
            <VIPImage identity={props.userDetails.identity}  />
            <span>
              {props.userDetails.username && props.userDetails.username !== ""
                ? props.userDetails.username
                : props.userDetails.first_name}
            </span>
            
            {showMainNotification && <div className="notification_round"></div>}
          </Dropdown.Toggle>
        )}

        <Dropdown.Menu>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              "small_circle  " +
              (activeMenu === "/dashboard/account-details" ? "active" : "")
            }
            to="/dashboard/account-details"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              width="22"
              height="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <path d="M637 161.1l-19.1-19.2c-4-4.1-10.6-4.1-14.6 0L500.2 245.6l-47.4-47.7c-4-4.1-10.6-4.1-14.6 0L419 217.1c-4 4.1-4 10.6 0 14.7l73.8 74.3c4 4.1 10.6 4.1 14.6 0L637 175.8c4-4 4-10.6 0-14.7zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.8 0-42.4 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464z" />
            </svg>
            <span className="menuText">{__("Account Details")}</span>
            {showMainNotification && <div className="notification_round"></div>}
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
             
              (activeMenu === "/dashboard/favorite-games" ? "active" : "")
            }
            to="/dashboard/favorite-games"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg width="22px" height="22px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z" fill="#000000"></path> </g></svg>
            <span className="menuText">{__("Favorite Games")}</span>
            
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              (activeMenu === "/dashboard/cashier" ? "active" : "") + " d-none"
            }
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
            to="/dashboard/cashier"
          >
            <svg
              width="22"
              height="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zm0 464H48V208h352v256zm0-304H48V48h352v112zM108.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm192 96h38.4c6.4 0 12.8-6.4 12.8-12.8V268.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm96-96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm0 96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8z" />
            </svg>
            <span className="menuText">
              {__("Cashier")}{" "}
              <Badge className="theme_bg radius_25">
                {userBalance.currency}
                {userBalance.total_balance}
              </Badge>
            </span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/transaction-history"
                ? "active d-none"
                : "d-none"
            }
            to="/dashboard/transaction-history"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              width="22"
              height="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M128 152v-32c0-4.4 3.6-8 8-8h208c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm8 88h208c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H136c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm299.1 159.7c-4.2 13-4.2 51.6 0 64.6 7.3 1.4 12.9 7.9 12.9 15.7v16c0 8.8-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h352c8.8 0 16 7.2 16 16v368c0 7.8-5.5 14.2-12.9 15.7zm-41.1.3H80c-17.6 0-32 14.4-32 32 0 17.7 14.3 32 32 32h314c-2.7-17.3-2.7-46.7 0-64zm6-352H80c-17.7 0-32 14.3-32 32v278.7c9.8-4.3 20.6-6.7 32-6.7h320V48z" />
            </svg>
            <span className="menuText">{__("Transaction History")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/gaming-history"
                ? "active d-none"
                : "d-none"
            }
            to="/dashboard/gaming-history"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              height="22"
              width="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path d="M370.5 138.9l-50.2-7.3-22.5-45.5c-4-8.1-15.7-8.2-19.7 0l-22.5 45.5-50.2 7.3c-9 1.3-12.6 12.4-6.1 18.8l36.3 35.4-8.6 50c-1.5 8.9 7.9 15.8 16 11.6l44.9-23.6 44.9 23.6c8 4.2 17.5-2.6 16-11.6l-8.6-50 36.3-35.4c6.7-6.4 3-17.5-6-18.8zm-60.3 44.4l5.2 30.6-27.4-14.4-27.5 14.4 5.2-30.6-22.2-21.6 30.7-4.5 13.7-27.8 13.7 27.8 30.7 4.5-22.1 21.6zM448 64V12c0-6.6-5.4-12-12-12H140c-6.6 0-12 5.4-12 12v52H12C5.4 64 0 69.4 0 76v61.6C0 199.7 68.1 272 160.7 285.7c29.4 60.7 73.7 90.3 111.3 96.9V480h-86c-14.4 0-26 11.7-26 26.1 0 3.3 2.7 5.9 6 5.9h244c3.3 0 6-2.6 6-5.9 0-14.4-11.6-26.1-26-26.1h-86v-97.4c37.7-6.6 81.9-36.2 111.3-96.9C508 272 576 199.6 576 137.6V76c0-6.6-5.4-12-12-12H448zM32 137.6V96h96v24c0 51.8 7 94.9 18.5 130.2C77.9 232.5 32 178 32 137.6zM288 352c-72 0-128-104-128-232V32h256v88c0 128-56 232-128 232zm256-214.4c0 40.4-46 94.9-114.5 112.6C441 214.9 448 171.8 448 120V96h96v41.6z" />
            </svg>
            <span className="menuText">{__("Gaming History")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              (activeMenu === "/dashboard/free-spins" ? "active" : "") 
            }
            to="/dashboard/free-spins"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              svgjs="http://svgjs.com/svgjs"
              xlink="http://www.w3.org/1999/xlink"
              height="22"
              width="22"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="22"
                width="22"
                viewBox="20.11 25.57 445.8 437.67"
              >
                <path
                  fill="#666666"
                  d="M370.203 25.574c-51.962-.07-134.69 39.665-212.467 106.908-105.35 91.08-162.303 197.81-127.316 238.28 18.474 21.37 58.867 19.968 108.39.476-5.416 19.54-4.192 35.717 4.91 46.244 16.727 19.35 56.123 14.81 103.09-7.556-4.062 14.072-3.303 25.733 3.198 33.252 12.79 14.793 44.6 9.873 81.523-9.772-3.955 10.502-4.084 19.25.517 24.57 9.158 10.593 34.315 4.552 61.724-13.066-3.608 6.83-4.456 12.655-1.686 15.86 5.57 6.443 23.665-.123 40.443-14.627 16.777-14.505 25.892-31.46 20.32-37.903-2.694-3.117-8.353-3.187-15.36-.81 22.21-25.036 32.348-49.734 23.025-60.518-4.444-5.14-12.68-6.387-23.117-4.307 25.718-34.37 35.86-66.023 22.863-81.056-4.827-5.583-12.086-8.512-21.61-8.763l-.002.002c-3.783-.1-7.884.213-12.244.896 26.956-41.706 36.07-78.49 19.84-97.26-8.66-10.017-23.86-14.06-42.633-12.264h-.005c-1.556.15-3.148.35-4.757.574 24.82-44.517 31.488-82.575 13.52-103.36-8.747-10.115-22.45-15.314-39.714-15.77-.81-.02-1.626-.03-2.45-.032zm-3.017 47.79c12.217-.03 21.736 3.206 27.664 10.062 10.874 12.578 7.59 35.378-6.362 63.21-40.125 8.965-93.027 38.37-143.734 82.208-49.904 43.143-86.16 90.686-101.318 128.795-28.996 9.584-51.49 9.75-62.206-2.648-25.29-29.25 24.273-114.272 110.963-189.22 66.373-57.383 135.082-92.315 174.993-92.41zm43.197 108.407c9.635-.037 17.15 2.515 21.844 7.945 10.515 12.163 4.622 36.545-13.237 65.44-27.833 6.597-64.24 26.655-98.9 56.618-34.575 29.89-59.638 62.81-70.215 89.278-31.05 13.373-55.99 15.67-66.44 3.583-20.032-23.168 20.108-90.146 88.77-149.508 52.57-45.45 106.7-73.227 138.178-73.354zm26.625 97.623c6.084.2 10.85 1.986 13.902 5.517 8.93 10.33.774 33.067-18.707 58.95-16.546 4.677-37.42 16.553-57.36 33.792-18.927 16.364-33.19 34.254-40.593 49.453-26.45 13.488-48.37 17.056-56.793 7.315-13.955-16.14 14.07-62.597 61.906-103.955 37.373-32.31 75.916-51.793 97.645-51.072zm9.22 78.34c3.72.125 6.636 1.214 8.5 3.37 6.783 7.846-2.435 27.462-21.222 47.876-6.588 2.883-14.007 7.602-21.178 13.8-6.634 5.737-12.03 11.86-15.82 17.577-21.725 14.166-41.042 19.656-47.522 12.163-8.516-9.85 8.352-38.398 37.54-63.633 22.802-19.715 46.405-31.595 59.7-31.153zm-.138 55.626c1.76.058 3.14.572 4.02 1.59 4.03 4.66-3.86 18.084-17.665 30.02-13.805 11.937-28.32 17.88-32.347 13.22-4.028-4.66 3.95-18.162 17.756-30.096 10.785-9.324 21.947-14.944 28.236-14.735z"
                  class="color000 svgShape"
                />
              </svg>
            </svg>
            <span className="menuText">{__("Free Spins")}</span>
            {props.freeSpinCount > 0 && (
              <>
                <div className="notify_content">
                  <i class="fas fa-bell"></i>
                  <div className="nuber_alart_count">{props.freeSpinCount}</div>
                </div>
              </>
            )}
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/notifications"
                ? "active d-none"
                : "d-none"
            }
            to="/dashboard/notifications"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              height="22"
              width="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z" />
            </svg>
            <span className="menuText">{__("Notifications")}</span>
            {props.notifictionCount > 0 && (
              <>
                <div className="notify_content">
                  <i class="fas fa-bell"></i>
                  <div className="nuber_alart_count">
                    {props.notifictionCount}
                  </div>
                </div>
              </>
            )}
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={activeMenu === "/dashboard/messages" ? "active" : ""}
            to="/dashboard/messages"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              height="22"
              width="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path d="M512 160h-96V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64h32v52c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4l76.9-43.5V384c0 35.3 28.7 64 64 64h96l108.9 61.6c2.2 1.6 4.7 2.4 7.1 2.4 6.2 0 12-4.9 12-12v-52h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64zM96 240H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H211.4l-11 6.2-56.4 31.9V240H96zm432 144c0 8.8-7.2 16-16 16h-80v38.1l-56.4-31.9-11-6.2H256c-8.8 0-16-7.2-16-16v-96h112c35.3 0 64-28.7 64-64v-16h96c8.8 0 16 7.2 16 16v160z" />
            </svg>
            <span className="menuText">{__("Messages")}</span>
            {props.notificationCount > 0 && (
              <>
                <div className="notify_content">
                  <i class="fas fa-bell"></i>
                  <div className="nuber_alart_count">{props.notificationCount}</div>
                </div>
              </>
            )}
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/responsible-gaming"
                ? "active d-none"
                : " d-none"
            }
            to="/dashboard/responsible-gaming"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              svgjs="http://svgjs.com/svgjs"
              xlink="http://www.w3.org/1999/xlink"
              width="22"
              height="22"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="222" height="22">
                <path
                  fill="#666666"
                  d="M5.36 0.9l-0.27-0.57c-0.083-0.197-0.275-0.333-0.499-0.333-0.1 0-0.193 0.027-0.274 0.074-0.217 0.074-0.372 0.279-0.372 0.52 0 0.087 0.020 0.169 0.056 0.242l0.319 0.577c-6.2 3.49-3.9 10.59-3.9 10.59h0.060c0.25-0.12 0.8-1.64 2.050-2.25s2.78-0.090 3-0.21l0.12-0.060c0.477-0.742 0.998-1.387 1.58-1.97l3.37 7.070c0.246 0.619 0.729 1.098 1.334 1.335 0.168 0.053 0.343 0.080 0.524 0.080 0.254 0 0.495-0.053 0.713-0.149l0.359-0.176c0.263-0.145 0.462-0.38 0.558-0.662 0.117-0.276 0.183-0.586 0.183-0.913 0-0.401-0.1-0.778-0.277-1.108-0.102-0.189-0.311-0.324-0.551-0.324-0.076 0-0.149 0.014-0.217 0.038-0.182 0.089-0.308 0.277-0.308 0.495 0 0.093 0.023 0.18 0.064 0.257s0.529 1.067-0.101 1.337-1.19-0.73-1.19-0.73l-3.42-7.060c0.372-0.043 0.803-0.067 1.24-0.067s0.868 0.024 1.292 0.072l0.068-0.065c0.25-0.12 0.8-1.64 2.050-2.25s2.78-0.090 3-0.21h0.060s-3.98-6.41-10.62-3.58zM7.36 6.36c-1.034 0.399-1.834 1.209-2.211 2.224-0.55-1.082-0.909-2.375-1.007-3.74-0.142-2.244 0.608-2.924 0.608-2.924l0.77-0.32c1.084 0.101 2.052 0.534 2.816 1.195 0.976 0.895 1.747 2.009 2.233 3.265-0.339-0.021-0.752-0.067-1.175-0.067-0.724 0-1.417 0.134-2.054 0.379z"
                  class="color444 svgShape"
                />
              </svg>
            </svg>
            <span className="menuText">{__("Responsible Gaming")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/verify" ? "active d-none" : "d-none"
            }
            to="/dashboard/verify"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              svgjs="http://svgjs.com/svgjs"
              xlink="http://www.w3.org/1999/xlink"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                // enable-background="new 0 0 910.288 910.287"
                viewBox="36.87 0 836.55 910.29"
              >
                <path
                  fill="#666666"
                  d="M873.206,202.06l-1.212-28.51l-28.386-2.915c-109.036-11.198-202.773-51.887-262.21-84.049    c-65.099-35.226-104.56-68.274-104.922-68.579L455.165,0L433.84,17.981c-0.392,0.33-39.853,33.379-104.951,68.604    c-59.437,32.162-153.173,72.851-262.209,84.049l-28.387,2.915l-1.212,28.51c-0.217,5.104-4.777,126.698,42.059,273.937    c27.637,86.887,67.549,164.736,118.627,231.396c64.139,83.701,145.948,149.68,243.155,196.102l14.221,6.793l14.221-6.793    c97.207-46.422,179.017-112.398,243.155-196.102c51.079-66.658,90.991-144.51,118.628-231.395    C877.982,328.759,873.423,207.165,873.206,202.06z M455.143,836.93c-81.095-41.209-149.731-97.887-204.194-168.646    c-46.393-60.275-82.812-130.998-108.248-210.201c-31.088-96.808-38.06-183.144-39.471-225.538    c43.735-6.494,87.949-17.421,131.833-32.597c42.9-14.836,85.598-33.752,126.907-56.221c41.915-22.798,73.81-44.573,93.172-58.812    c19.362,14.238,51.258,36.014,93.173,58.812c41.309,22.47,84.007,41.385,126.907,56.221    c43.896,15.181,88.123,26.108,131.87,32.602c-1.359,41.978-8.194,127.098-38.842,223.443    c-25.317,79.594-61.694,150.672-108.12,211.258C605.537,738.494,536.632,795.52,455.143,836.93z"
                  class="color000 svgShape"
                />
                <polygon
                  fill="#666666"
                  points="635.013 305.016 588.969 351.06 417.368 522.662 330.399 435.693 318.573 423.867 295.239 447.201 295.239 447.202 271.904 470.537 417.368 616 681.682 351.686"
                  class="color000 svgShape"
                />
              </svg>
            </svg>
            <span className="menuText">{__("Verify")}</span>
            {(!level2submitted || !level3submitted) && (
              <div className="notification_round"></div>
            )}

            {level2submitted && level3submitted && (
              <div className="notification_round orenge"></div>
            )}
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/account-activity"
                ? "active d-none"
                : "d-none"
            }
            to="/dashboard/account-activity"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              height="22"
              width="22"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z" />
            </svg>
            <span className="menuText">{__("Account Activity")}</span>
          </Link>
          {/* <Link hreflang={Translator.getSelectedLanguage().code}
            className={activeMenu === "/dashboard/my-games" ? "active" : ""}
            to="/dashboard/my-games"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              id="SvgjsSvg1001"
              width="22"
              height="22"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xlink="http://www.w3.org/1999/xlink"
              svgjs="http://svgjs.com/svgjs"
            >
              <defs id="SvgjsDefs1002"></defs>
              <g id="SvgjsG1008">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  enable-background="new 0 0 484.8 484.8"
                  viewBox="0 0 484.8 484.8"
                  width="22"
                  height="22"
                >
                  <path
                    d="M242.4,484.8c133.7,0,242.4-108.8,242.4-242.4C484.8,108.7,376,0,242.4,0C108.7,0,0,108.7,0,242.4
				S108.7,484.8,242.4,484.8z M242.4,34.3c114.8,0,208.1,93.4,208.1,208.1c0,114.8-93.4,208.1-208.1,208.1
				c-114.8,0-208.1-93.4-208.1-208.1C34.3,127.6,127.6,34.3,242.4,34.3z"
                    fill="#666666"
                    class="color000 svgShape"
                  ></path>
                  <path
                    d="M230.1,380.6l0.2,0.2c3.2,3.2,7.6,5.1,12.1,5.1l0,0c4.5,0,8.9-1.8,12.1-5l108.9-108.8c16.1-16.1,24.9-37.4,24.9-60.1
				s-8.8-44.1-24.9-60.1c-16-16-37.4-24.9-60-24.9c-22.7,0-44,8.9-60.1,24.9l-0.9,0.9l-1-1c-16.1-16.1-37.5-24.9-60.2-24.9
				s-44,8.8-60,24.9c-33.1,33.1-33.1,87,0.1,120.2L230.1,380.6z M145.6,176c9.6-9.6,22.2-14.8,35.7-14.8s26.3,5.3,35.9,14.9
				l13.1,13.1c6.7,6.7,17.6,6.7,24.3,0l13-13c9.6-9.6,22.3-14.9,35.9-14.9c13.5,0,26.2,5.3,35.8,14.8c9.6,9.6,14.8,22.3,14.8,35.8
				s-5.3,26.3-14.9,35.9l-96.7,96.7l-96.8-96.8c-9.6-9.6-14.9-22.3-14.9-35.8C130.7,198.3,136,185.6,145.6,176z"
                    fill="#666666"
                    class="color000 svgShape"
                  ></path>
                </svg>
              </g>
            </svg>
            <span className="menuText">{__("My Games")}</span>
          </Link> */}
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={
              activeMenu === "/dashboard/refer-and-earn" ? "active" : ""
            }
            to="/dashboard/refer-and-earn"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              id="SvgjsSvg1001"
              width="22"
              height="22"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xlink="http://www.w3.org/1999/xlink"
              svgjs="http://svgjs.com/svgjs"
            >
              <defs id="SvgjsDefs1002"></defs>
              <g id="SvgjsG1008">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  version="1.0"
                  viewBox="0 0 980 980"
                >
                  <g
                    transform="matrix(.1 0 0 -.1 0 980)"
                    fill="#666666"
                    class="color000 svgShape"
                  >
                    <path
                      d="M4640 9793 c-381 -26 -614 -62 -940 -143 -591 -147 -1172 -420 -1675-785 -406 -296 -815 -706 -1103 -1108 -728 -1016 -1039 -2244 -881 -3482 118
-922 488 -1770 1094 -2507 140 -170 461 -491 633 -633 1073 -885 2424 -1273
3787 -1090 1037 140 1999 608 2750 1337 299 290 537 585 767 951 101 161 313
582 384 762 615 1567 393 3326 -591 4680 -150 206 -300 380 -500 581 -392 393
-793 684 -1275 925 -603 301 -1200 462 -1880 509 -133 9 -461 11 -570 3z m586
-473 c1287 -101 2440 -733 3221 -1765 411 -545 712 -1243 822 -1915 55 -332
75 -740 52 -1047 -73 -958 -415 -1802 -1030 -2543 -186 -224 -477 -501 -717
-681 -644 -487 -1360 -773 -2194 -876 -207 -25 -753 -25 -960 0 -1047 130
-1930 555 -2655 1282 -983 984 -1443 2351 -1254 3729 163 1192 809 2270 1785
2978 234 170 409 276 660 399 499 244 1043 393 1594 438 152 12 526 13 676 1z"
                      fill="#666666"
                      class="color000 svgShape"
                    ></path>
                    <path
                      d="M3707 7949c-278-29-554-183-720-402-321-420-293-996 67-1374 240-253 598-376 929-318 97 17 247 62 247 74 0 5-18 47-41 95-22 48-52 131-67 184-23 87-26 114-26 272 0 158 3 185 27 273 32 118 98 261 167 361 86 125 250 270 378 335l43 22-33 45c-174 243-454 402-759 434-56 5-109 9-118 9-9-1-51-5-94-10zM5489 7414c-413-74-732-349-863-744-46-139-60-244-53-394 15-330 178-635 445-835 127-95 317-175 484-201 111-18 331-9 434 18 424 112 725 429 816 862 28 135 21 354-17 490-100 363-370 650-720 764-168 54-365 70-526 40zM3655 5414c-16-2-70-9-120-15-49-6-148-26-220-44-366-94-680-272-957-543-420-411-660-950-694-1560l-7-122 674 2 673 3 9 35c55 209 180 500 302 700 272 448 711 868 1135 1084 133 69 213 100 343 135 75 21 95 30 85 38-28 23-257 132-348 166-112 42-258 80-390 102-90 15-420 28-485 19zM5510 4780c-436-34-847-199-1200-480-113-90-308-292-396-410-296-396-463-861-490-1363l-7-127 2251 0 2252 0 0 93c0 306-94 686-249 1002-194 394-460 699-821 938-389 257-878 384-1340 347z"
                      fill="#666666"
                      class="color000 svgShape"
                    ></path>
                  </g>
                </svg>
              </g>
            </svg>
            <span className="menuText">{__("Refer and Earn")}</span>
          </Link>
          {/* <Link hreflang={Translator.getSelectedLanguage().code}
            className={activeMenu === "/store" ? "active" : ""}
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
            to="/store"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              svgjs="http://svgjs.com/svgjs"
              xlink="http://www.w3.org/1999/xlink"
              width="22"
              height="22"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                enable-background="new 0 0 32 32"
                viewBox="1 3 30 27"
              >
                <path
                  fill="#666666"
                  d="M16,28c0,1.105-0.895,2-2,2s-2-0.895-2-2c0-1.105,0.895-2,2-2S16,26.895,16,28z M25,26  c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2s2-0.895,2-2C27,26.895,26.105,26,25,26z M27,21H12.281l0.5,2H27c0.553,0,1,0.448,1,1  s-0.447,1-1,1H12c-0.459,0-0.858-0.312-0.97-0.757L6.219,5H2C1.447,5,1,4.552,1,4s0.447-1,1-1h5c0.459,0,0.858,0.312,0.97,0.757  L8.78,7h0.001H30c0.308,0,0.599,0.142,0.788,0.385s0.257,0.559,0.182,0.858l-3,12C27.858,20.688,27.459,21,27,21z M22,10  c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1S22,9.448,22,10z M18,10c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1  S18,9.448,18,10z M14,10c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1S14,9.448,14,10z M12,10c0-0.552-0.448-1-1-1  s-1,0.448-1,1c0,0.552,0.448,1,1,1S12,10.552,12,10z M14,14c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S14,14.552,14,14z   M16,18c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S16,18.552,16,18z M18,14c0-0.552-0.448-1-1-1s-1,0.448-1,1  c0,0.552,0.448,1,1,1S18,14.552,18,14z M20,18c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S20,18.552,20,18z M22,14  c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S22,14.552,22,14z M24,18c0-0.552-0.448-1-1-1s-1,0.448-1,1  c0,0.552,0.448,1,1,1S24,18.552,24,18z M26,14c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S26,14.552,26,14z M27,11  c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1s-1,0.448-1,1C26,10.552,26.448,11,27,11z"
                  class="color111918 svgShape"
                />
              </svg>
            </svg>
            <span className="menuText">{__("Store")}</span>
          </Link> */}
          {/* <Link hreflang={Translator.getSelectedLanguage().code}
            className={activeMenu === "/tickets" ? "active" : ""}
            to="/tickets"
            onClick={() => {
              setDefaultShowing(false);
              props.setShowLeftSidebar(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              svgjs="http://svgjs.com/svgjs"
              xlink="http://www.w3.org/1999/xlink"
              width="22"
              height="22"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                enable-background="new 0 0 985.333 985.334"
                viewBox="0 0 985.333 985.334"
              >
                <path
                  fill="#666666"
                  d="M868.565,492.8c-4.4,22.101-24,38.2-47.5,39.2c-7.4,0.3-13.7,5.7-15.101,13c-1.5,7.3,2.2,14.7,8.9,17.8
		c21.3,10,33.2,32.4,28.7,54.5l-4.2,21c-5.5,27.7-36.101,45-62.9,38.4c-7.5-1.8-15.2-3.2-22.8-4.7c-11.2-2.2-22.4-4.5-33.6-6.7
		c-14.801-3-29.601-5.899-44.4-8.899c-17.6-3.5-35.3-7.101-52.9-10.601c-19.699-4-39.399-7.899-59.1-11.899
		c-21-4.2-42.1-8.4-63.1-12.7c-21.601-4.3-43.2-8.7-64.7-13c-21.4-4.3-42.7-8.601-64.101-12.9c-20.399-4.1-40.8-8.2-61.199-12.3
		c-18.7-3.7-37.3-7.5-56-11.2c-16.2-3.2-32.4-6.5-48.5-9.7c-12.9-2.6-25.8-5.199-38.8-7.8c-8.9-1.8-17.801-3.6-26.7-5.399
		c-4.101-0.801-8.2-1.7-12.3-2.5c-0.2,0-0.4-0.101-0.601-0.101c2.2,10.4,1.2,21.5-3.6,31.9c-10.101,21.8-33.601,33.2-56.2,28.8
		c-6.7-1.3-14,1.2-16.9,7.4l-9,19.5c-2.899,6.199,0,13.399,5.301,17.699c1,0.801,721.8,333.101,722.999,333.4
		c6.7,1.3,14-1.2,16.9-7.4l9-19.5c2.9-6.199,0-13.399-5.3-17.699c-18-14.301-24.601-39.601-14.5-61.4c10.1-21.8,33.6-33.2,56.2-28.8
		c6.699,1.3,14-1.2,16.899-7.4l9-19.5c2.9-6.2,0-13.399-5.3-17.7c-18-14.3-24.6-39.6-14.5-61.399s33.6-33.2,56.2-28.8
		c6.7,1.3,14-1.2,16.9-7.4l9-19.5c2.899-6.2,0-13.4-5.301-17.7c-18-14.3-24.6-39.6-14.5-61.4c10.101-21.8,33.601-33.199,56.2-28.8
		c6.7,1.3,14-1.2,16.9-7.399l9.899-21.601c2.9-6.2,0.2-13.5-6-16.399l-107.699-49.7L868.565,492.8z"
                  class="color000 svgShape"
                />
                <path
                  fill="#666666"
                  d="M9.665,485.9c1.2,0.6,779.3,156.699,780.6,156.699c6.801-0.3,13.4-4.5,14.7-11.1l4.2-21c1.3-6.7-3.1-13.1-9.3-16
		c-20.8-9.8-33.101-32.8-28.4-56.4c4.7-23.6,25-40.1,48-41.1c6.8-0.3,13.4-4.5,14.7-11.1l3.1-15.4l1.101-5.7
		c1.3-6.7-3.101-13.1-9.3-16c-20.801-9.8-33.101-32.8-28.4-56.399c4.7-23.601,25-40.101,48-41.101c6.8-0.3,13.4-4.5,14.7-11.1
		l4.2-21c1.3-6.7-3.101-13.1-9.301-16c-20.8-9.8-33.1-32.8-28.399-56.4c4.7-23.6,25-40.1,48-41.1c6.8-0.3,13.399-4.5,14.7-11.1
		l4.699-23.3c1.301-6.7-3-13.2-9.699-14.5c0,0-781.9-156.8-782.7-156.8c-5.8,0-10.9,4.1-12.1,9.9l-4.7,23.3
		c-1.3,6.7,3.1,13.1,9.3,16c20.8,9.8,33.1,32.8,28.4,56.4c-4.7,23.6-25,40.1-48,41.1c-6.801,0.3-13.4,4.5-14.7,11.1l-4.2,21
		c-1.3,6.7,3.1,13.1,9.3,16c20.8,9.8,33.101,32.8,28.4,56.4c-4.7,23.6-25,40.1-48,41.1c-6.8,0.3-13.4,4.5-14.7,11.1l-4.2,21
		c-1.3,6.7,3.101,13.1,9.3,16c20.801,9.8,33.101,32.8,28.4,56.4c-4.7,23.601-25,40.101-48,41.101c-6.8,0.3-13.4,4.5-14.7,11.1
		l-4.2,21C-0.935,476.7,3.464,483,9.665,485.9z M676.165,229.6c2.7-13.5,15.9-22.3,29.4-19.6s22.3,15.9,19.6,29.4l-33,164.2
		l-20.3,101.2c-2.4,11.9-12.8,20.101-24.5,20.101c-1.601,0-3.3-0.2-4.9-0.5c-13.5-2.7-22.3-15.9-19.6-29.4l22.7-112.9L676.165,229.6
		z M225.365,139.1c2.7-13.5,15.9-22.3,29.4-19.6s22.3,15.9,19.6,29.4l-11.4,56.7l-12.899,64.3l-10.4,51.8l-18.5,92.6
		c-2.399,11.9-12.8,20.101-24.5,20.101c-1.6,0-3.3-0.2-4.899-0.5c-0.7-0.101-1.4-0.301-2-0.5c-12.4-3.601-20.101-16.101-17.5-28.9
		l3.699-18.7l9.7-48.4L225.365,139.1z"
                  class="color000 svgShape"
                />
              </svg>
            </svg>
            <span className="menuText">{__("Tickets")}</span>
          </Link> */}

          <Link
            hreflang={Translator.getSelectedLanguage().code}
            onClick={logout}
          >
            <svg
              id="SvgjsSvg1001"
              width="22"
              height="22"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xlink="http://www.w3.org/1999/xlink"
              svgjs="http://svgjs.com/svgjs"
            >
              <defs id="SvgjsDefs1002"></defs>
              <g id="SvgjsG1008">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  enable-background="new 0 0 30.143 30.143"
                  viewBox="0 0 30.143 30.143"
                  width="22"
                  height="22"
                >
                  <path
                    fill="#666666"
                    d="M20.034,2.357v3.824c3.482,1.798,5.869,5.427,5.869,9.619c0,5.98-4.848,10.83-10.828,10.83
		c-5.982,0-10.832-4.85-10.832-10.83c0-3.844,2.012-7.215,5.029-9.136V2.689C4.245,4.918,0.731,9.945,0.731,15.801
		c0,7.921,6.42,14.342,14.34,14.342c7.924,0,14.342-6.421,14.342-14.342C29.412,9.624,25.501,4.379,20.034,2.357z"
                    class="color030104 svgShape"
                  ></path>
                  <path
                    fill="#666666"
                    d="M14.795,17.652c1.576,0,1.736-0.931,1.736-2.076V2.08c0-1.148-0.16-2.08-1.736-2.08
		c-1.57,0-1.732,0.932-1.732,2.08v13.496C13.062,16.722,13.225,17.652,14.795,17.652z"
                    class="color030104 svgShape"
                  ></path>
                </svg>
              </g>
            </svg>
            <span className="menuText">
              {""} {__("Logout")}
            </span>
          </Link>
          {props.isMobileDevice && (
            <div className="button_close d-none">
              <i
                onClick={() => {
                  setDefaultShowing(false);
                }}
                class="fa fa-times"
                aria-hidden="true"
              ></i>
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
      {/* {defualtShowing && (
        <div
          onClick={() => {
            setDefaultShowing(false);
            props.setShowLeftSidebar(false);
          }}
          className="main_overlay"
        ></div>
      )} */}
    </>
  );
};

export default UserDropDownMenu;
